import { proxy } from "@/util/proxy.mjs";

type AccountRefs = {
  isLoggedIn: boolean;
  activeSubscriber: boolean;
};

export const accountRefs = proxy<AccountRefs>({
  isLoggedIn: false,
  activeSubscriber: false,
});
